import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserHistory } from 'history';
import App from './App.tsx';
import './styles/fonts.css';
import './styles/setup.css';

import * as Sentry from '@sentry/react';

const env = import.meta.env.VITE_SENTRY_ENV || 'development';

export const history = createBrowserHistory();

Sentry.init({
    dsn: 'https://9ae457399d399b5e10a358929b13c556@o1412149.ingest.sentry.io/4506535918764032',
    enabled: env !== 'development',
    tracePropagationTargets: [
        'localhost',
        /^https:\/\/checkout\.admitone\.com/,
        /^https:\/\/a1-client-web-checkout-dev\.vercel\.app/,
        /^https:\/\/graphql\.admitone\.com/,
    ],
    integrations: [
        Sentry.reactRouterV5BrowserTracingIntegration({ history }),
        Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
        }),
    ],
    environment: env,
    // Performance Monitoring
    tracesSampleRate: 0.1,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

(async () => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
})();
